import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core'

import React, { FC } from 'react'
import styled from 'styled-components'

import CompanyProductTableBody from '../../components/table/CompanyProductTableBody'
import { ProductListInterface } from '../../interfaces/product'
import TablePaperContainer from '../common/TablePaperContainer'

const StyledTableHead = styled(TableHead)`
  background-color: rgba(0, 0, 0, 0.02);
`

const StyledTableHeadCell = styled(TableCell)`
  font-size: 16px !important;
  font-weight: 700 !important;
`
type Props = {
  productList: ProductListInterface[]
  companyProductHandlers: {
    archiveProduct: (productId: string) => () => void
  }
  handleOpenProductForm: (productId?: string) => () => void
}

const CompanyProductListTable: FC<Record<string, unknown> & Props> = ({
  productList,
  companyProductHandlers,
  handleOpenProductForm
}: Props) => {
  const columnNameList = [
    'Id',
    'Product Name',
    'Category',
    'Updated At',
    'Updated By',
    'Action'
  ]

  return (
    <TablePaperContainer>
      <TableContainer component={Paper} style={{ height: 'inherit' }}>
        <Table aria-label="sticky pagination table">
          <StyledTableHead>
            <TableRow>
              {columnNameList.map((name) => (
                <StyledTableHeadCell align="center">{name}</StyledTableHeadCell>
              ))}
            </TableRow>
          </StyledTableHead>
          <CompanyProductTableBody
            productList={productList}
            archiveProduct={companyProductHandlers.archiveProduct}
            handleOpenProductForm={handleOpenProductForm}
          />
        </Table>
      </TableContainer>
    </TablePaperContainer>
  )
}

export default CompanyProductListTable
